import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { Paper } from '../../Common/Components';

export interface MerchantRecoverPasswordSuccessProps {
  onSendAgain: () => void;
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'grid',
  },
  header: {
    display: 'grid',
    gridGap: '16px',
  },
  sendAgain: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
}));

const MerchantRecoverPasswordSuccessView: React.FC<MerchantRecoverPasswordSuccessProps> = ({
  onSendAgain,
}) => {
  const classes = useStyles();

  return (
    <Paper className={classes.container}>
      <div className={classes.header}>
        <Typography variant="h1" color="primary">
          If this email address is an active account, you will receive an email shortly.
        </Typography>

        <Typography variant="h2" color="textPrimary">
          If you do not receive a reset link, check your spam folder or{' '}
          <span className={classes.sendAgain} onClick={onSendAgain}>
            send again
          </span>
          .
        </Typography>
      </div>
    </Paper>
  );
};

export default MerchantRecoverPasswordSuccessView;
